import { getFirAnalytics } from '../../Api/firebase/firebaseConnect'
import { logEvent as firLogEvent } from "firebase/analytics"
import { executeWithRetry } from '../Networking/networkHelpers'

export const logEvent = async (name: string, params?: any | undefined) => {
    await executeWithRetry(async () => {
        const fa = await getFirAnalytics()
        firLogEvent(fa, name, params)
    }, `log analytics event: ${name}`)
}